// Mock data for Attribute Value Mapping screen

export const valueMappingData: Record<string, any> = {
  context: {
    attributeName: 'Size',
    attributeId: 'attr-size-001',
    sourceMarketplace: 'Flipkart',
    baseMarketplace: 'Amazon',
    mappingType: 'NUMERIC_TO_ENUM',
    status: 'VALUE_MAPPING_REQUIRED',
    sourceAttributeType: 'NUMERIC + UNIT',
    baseAttributeType: 'ENUM',
  },

  // Source values from Flipkart (NUMERIC + UNIT)
  sourceValues: [
    { id: 'sv-001', value: '20', unit: 'cm', aiHint: 'Suggested: S', confidence: 0.85 },
    { id: 'sv-002', value: '22', unit: 'cm', aiHint: 'Suggested: S', confidence: 0.78 },
    { id: 'sv-003', value: '24', unit: 'cm', aiHint: 'Suggested: M', confidence: 0.92 },
    { id: 'sv-004', value: '26', unit: 'cm', aiHint: 'Suggested: M', confidence: 0.88 },
    { id: 'sv-005', value: '28', unit: 'cm', aiHint: 'Suggested: L', confidence: 0.90 },
    { id: 'sv-006', value: '30', unit: 'cm', aiHint: 'Suggested: L', confidence: 0.82 },
    { id: 'sv-007', value: '32', unit: 'cm', aiHint: 'Suggested: XL', confidence: 0.86 },
    { id: 'sv-008', value: '34', unit: 'cm', aiHint: 'Suggested: XL', confidence: 0.75 },
    { id: 'sv-009', value: '36', unit: 'cm', aiHint: 'Suggested: XXL', confidence: 0.70 },
    { id: 'sv-010', value: 'Free Size', unit: null, aiHint: null, confidence: 0 },
  ],

  // Base values from Amazon (ENUM)
  baseValues: [
    { id: 'bv-001', value: 'XS', label: 'Extra Small' },
    { id: 'bv-002', value: 'S', label: 'Small' },
    { id: 'bv-003', value: 'M', label: 'Medium' },
    { id: 'bv-004', value: 'L', label: 'Large' },
    { id: 'bv-005', value: 'XL', label: 'Extra Large' },
    { id: 'bv-006', value: 'XXL', label: 'Double Extra Large' },
  ],

  // Pre-filled mappings (some already suggested)
  initialMappings: {
    'sv-001': 'S',
    'sv-002': 'S',
    'sv-003': 'M',
    'sv-004': null, // Not mapped yet
    'sv-005': null,
    'sv-006': null,
    'sv-007': null,
    'sv-008': null,
    'sv-009': null,
    'sv-010': null,
  },

  // Range suggestions for UI hint
  rangeSuggestions: [
    { range: '20-22 cm', suggested: 'S', confidence: 0.82 },
    { range: '24-26 cm', suggested: 'M', confidence: 0.90 },
    { range: '28-30 cm', suggested: 'L', confidence: 0.86 },
    { range: '32-34 cm', suggested: 'XL', confidence: 0.80 },
    { range: '36+ cm', suggested: 'XXL', confidence: 0.70 },
  ],
};

// Additional mock scenarios for different mapping types
export const colorMappingData: Record<string, any> = {
  context: {
    attributeName: 'Color',
    attributeId: 'attr-color-001',
    sourceMarketplace: 'Flipkart',
    baseMarketplace: 'Amazon',
    mappingType: 'ENUM_TO_ENUM',
    status: 'VALUE_MAPPING_REQUIRED',
    sourceAttributeType: 'ENUM',
    baseAttributeType: 'ENUM',
  },
  sourceValues: [
    { id: 'cv-001', value: 'Sky Blue', unit: null, aiHint: 'Suggested: Blue', confidence: 0.95 },
    { id: 'cv-002', value: 'Navy Blue', unit: null, aiHint: 'Suggested: Blue', confidence: 0.88 },
    { id: 'cv-003', value: 'Crimson Red', unit: null, aiHint: 'Suggested: Red', confidence: 0.92 },
    { id: 'cv-004', value: 'Forest Green', unit: null, aiHint: 'Suggested: Green', confidence: 0.85 },
    { id: 'cv-005', value: 'Jet Black', unit: null, aiHint: 'Suggested: Black', confidence: 0.98 },
  ],
  baseValues: [
    { id: 'bc-001', value: 'Red', label: 'Red' },
    { id: 'bc-002', value: 'Blue', label: 'Blue' },
    { id: 'bc-003', value: 'Green', label: 'Green' },
    { id: 'bc-004', value: 'Black', label: 'Black' },
    { id: 'bc-005', value: 'White', label: 'White' },
    { id: 'bc-006', value: 'Yellow', label: 'Yellow' },
  ],
};
